var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 300,
    viewBox: "0 0 512 512",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m319.579 342.685h110.998c4.15 0 7.515-3.364 7.515-7.515s-3.365-7.515-7.515-7.515h-110.998c-4.15 0-7.515 3.364-7.515 7.515s3.365 7.515 7.515 7.515z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.579 313.725h110.998c4.15 0 7.515-3.364 7.515-7.515s-3.365-7.515-7.515-7.515h-110.998c-4.15 0-7.515 3.364-7.515 7.515s3.365 7.515 7.515 7.515z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.011 440.476h-10.055v-148.028c0-2.917-1.688-5.57-4.33-6.806l-29.763-13.926-6.168-68.383c-.373-4.134-4.025-7.167-8.159-6.809-4.134.373-7.182 4.026-6.809 8.16l5.381 59.661-67.548-31.606 8.91-98.788h46.878l3.68 40.798c.373 4.134 4.029 7.176 8.16 6.809 4.134-.373 7.182-4.026 6.809-8.16l-7.792-86.387c-.349-3.873-3.596-6.84-7.484-6.84h-53.622c-3.888 0-7.135 2.967-7.484 6.84l-3.486 38.654c0 .002 0 .004-.001.007l-9.046 100.293-60.85-28.472v-53.143c0-5.526-6.047-9.214-10.965-6.676l-68.635 35.474-9.21-102.105c0-.001 0-.003 0-.004l-3.486-38.654c-.349-3.873-3.596-6.839-7.484-6.839h-53.622c-3.888 0-7.135 2.967-7.484 6.839l-3.486 38.652c0 .003 0 .005-.001.008l-13.809 153.054-70.941 36.666c-2.496 1.291-4.064 3.866-4.064 6.676v67.73c0 4.151 3.365 7.515 7.515 7.515s7.515-3.364 7.515-7.515v-63.155l223.125-115.323v283.783h-223.126v-75.247c0-4.151-3.364-7.515-7.515-7.515s-7.515 3.364-7.515 7.515v75.247h-10.055c-12.676 0-22.989 10.313-22.989 22.989s10.313 22.989 22.989 22.989h355.889c4.15 0 7.515-3.364 7.515-7.515s-3.364-7.515-7.515-7.515h-355.889c-4.389 0-7.96-3.57-7.96-7.96 0-4.389 3.571-7.96 7.96-7.96h466.022c4.389 0 7.96 3.57 7.96 7.96 0 4.389-3.571 7.96-7.96 7.96h-80.073c-4.15 0-7.515 3.364-7.515 7.515s3.365 7.515 7.515 7.515h80.073c12.676 0 22.989-10.313 22.989-22.989s-10.313-22.989-22.989-22.989zm-75.159-345.276 2.139 23.72h-44.166l2.139-23.72zm-234.271-54.625 2.139 23.719h-44.166l2.139-23.719zm-43.383 38.748h46.877l9.135 101.277-68.332 35.318zm150.031 134.761 177.697 83.144v143.248h-27.284v-57.165c0-4.151-3.365-7.515-7.515-7.515h-108.1c-4.15 0-7.515 3.364-7.515 7.515v57.165h-27.284v-226.392zm135.384 226.392h-93.07v-49.651h93.07z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.1 332.464h30.012c4.15 0 7.515-3.364 7.515-7.515v-37.478c0-4.151-3.365-7.515-7.515-7.515h-30.012c-4.15 0-7.515 3.364-7.515 7.515v37.478c.001 4.151 3.365 7.515 7.515 7.515zm7.515-37.478h14.983v22.449h-14.983z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.586 401.661c0 4.151 3.365 7.515 7.515 7.515h30.012c4.15 0 7.515-3.364 7.515-7.515v-37.478c0-4.151-3.365-7.515-7.515-7.515h-30.013c-4.15 0-7.515 3.364-7.515 7.515v37.478zm15.029-29.963h14.983v22.448h-14.983z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.356 332.464h30.012c4.15 0 7.515-3.364 7.515-7.515v-37.478c0-4.151-3.365-7.515-7.515-7.515h-30.012c-4.15 0-7.515 3.364-7.515 7.515v37.478c0 4.151 3.365 7.515 7.515 7.515zm7.514-37.478h14.983v22.449h-14.983z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.841 401.661c0 4.151 3.365 7.515 7.515 7.515h30.012c4.15 0 7.515-3.364 7.515-7.515v-37.478c0-4.151-3.365-7.515-7.515-7.515h-30.012c-4.15 0-7.515 3.364-7.515 7.515zm15.029-29.963h14.983v22.448h-14.983z",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactory);
export default __webpack_public_path__ + "static/media/icon-factory.a67aa35e575862d0a9e09195d37191c4.svg";
export { ForwardRef as ReactComponent };